import CameraAltOutlinedIcon from '@mui/icons-material/CameraAltOutlined';
import { Modal, Upload, UploadFile, Form } from "antd";
import { RcFile } from "antd/es/upload";
import { useState, useEffect } from "react";

type uploadImageProp = {
  name: string;
  label: string;
  defaultImage?: string;
};

const UploadImage = ({ name, label, defaultImage }: uploadImageProp) => {
  const [imageUrl, setImageUrl] = useState<string | undefined>(defaultImage);
  const [previewOpen, setPreviewOpen] = useState<boolean>(false);
  const [fileList, setFileList] = useState<UploadFile[]>([]);
  const [err, setError] = useState<boolean>(false);
  const form = Form.useFormInstance();

  useEffect(() => {
    if (defaultImage) {
      setFileList([
        {
          uid: '-1',
          name: 'image.png',
          status: 'done',
          url: defaultImage,
        },
      ]);
      setImageUrl(defaultImage);
    }
  }, [defaultImage]);

  const uploadButton = (
    <div>
      <CameraAltOutlinedIcon />
      <div style={{ marginTop: 8 }}>Upload</div>
    </div>
  );

  const beforeUpload = (file: RcFile) => {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    const isLt1M = file.size < 1048576;
  
    if (!isJpgOrPng || !isLt1M) {
      setError(true);
      return Upload.LIST_IGNORE;
    }
  
    setError(false);
    return true; 
  };  

  const getBase64 = (file: RcFile): Promise<string> =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = (error) => reject(error);
    });

  const handlePreview = async (file: UploadFile) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj as RcFile);
    }

    setImageUrl(file.url || (file.preview as string));
    setPreviewOpen(true);
  };

  const handleChange = async (info: any) => {
    const file = info.file.originFileObj;
    if (!err && file) {
      const base64 = await getBase64(file); 
      setFileList(info.fileList);
      setImageUrl(base64); 
      form.setFieldValue(name, file); 
      setError(false);
    } else {
      setError(true);
    }
  };
  

  const handleCancel = () => setPreviewOpen(false);

  return (
    <>
      <Form.Item
        name={name}
        label={label}
        rules={[
          {
            required: false,
            message: "Image is required",
          },
          {
            validator(_, value) {
              if (err) {
                return Promise.reject('Image should be png/jpeg and size should be less than 1MB');
              } else {
                return Promise.resolve();
              }
            },
          },
        ]}
      >
        <Upload
          name="avatar"
          listType="picture-circle"
          showUploadList={false} // Hides eye and delete icons
          beforeUpload={beforeUpload}
          onChange={handleChange}
          className="custom-circle-upload"
        >
          {imageUrl ? (
            <img
              src={imageUrl}
              alt="avatar"
              className="circle-img"
              style={{
                width: '100px',
                height: '100px',
                objectFit: 'cover',
                borderRadius: '50%',
              }}
            />
          ) : (
            uploadButton
          )}
        </Upload>
      </Form.Item>
      <Modal open={previewOpen} footer={null} onCancel={handleCancel}>
        <img alt="example" style={{ width: '100%' }} src={imageUrl} />
      </Modal>
    </>
  );
};

export default UploadImage;